export const GET_PROGRAMS = {
  INITIATE: 'GET_PROGRAMS_INITIATE',
  SUCCESS: 'GET_PROGRAMS_SUCCESS',
  FAILED: 'GET_PROGRAMS_FAILED',
};

export const GET_TOP_PROGRAMS = {
  INITIATE: 'GET_TOP_PROGRAMS_INITIATE',
  SUCCESS: 'GET_TOP_PROGRAMS_SUCCESS',
  FAILED: 'GET_TOP_PROGRAMS_FAILED',
};

export const CREATE_PROGRAM = {
  INITIATE: 'CREATE_PROGRAM_INITIATE',
  SUCCESS: 'CREATE_PROGRAM_SUCCESS',
  FAILED: 'CREATE_PROGRAM_FAILED',
};

export const REVIEW_PROGRAM = {
  INITIATE: 'REVIEW_PROGRAM_INITIATE',
  SUCCESS: 'REVIEW_PROGRAM_SUCCESS',
  FAILED: 'REVIEW_PROGRAM_FAILED',
};

export const GET_PROGRAM_INFO = {
  INITIATE: 'GET_PROGRAM_INFO_INITIATE',
  SUCCESS: 'GET_PROGRAM_INFO_SUCCESS',
  FAILED: 'GET_PROGRAM_INFO_FAILED',
};

export const GET_PROGRAM_DETAILS = {
  INITIATE: 'GET_PROGRAM_DETAILS_INITIATE',
  SUCCESS: 'GET_PROGRAM_DETAILS_SUCCESS',
  FAILED: 'GET_PROGRAM_DETAILS_FAILED',
};

export const GET_PROGRAM_STATUS = {
  INITIATE: 'GET_PROGRAM_STATUS_INITIATE',
  SUCCESS: 'GET_PROGRAM_STATUS_SUCCESS',
  FAILED: 'GET_PROGRAM_STATUS_FAILED',
};

export const REVIEW_PROGRAM_TO_EMPLOYEE = {
  INITIATE: 'REVIEW_PROGRAM_TO_EMPLOYEE_INITIATE',
  SUCCESS: 'REVIEW_PROGRAM_TO_EMPLOYEE_SUCCESS',
  FAILED: 'REVIEW_PROGRAM_TO_EMPLOYEE_FAILED',
};

export const GET_EMPLOYEES_FOR_PROGRAM = {
  INITIATE: 'GET_EMPLOYEES_FOR_PROGRAM_INITIATE',
  SUCCESS: 'GET_EMPLOYEES_FOR_PROGRAM_SUCCESS',
  FAILED: 'GET_EMPLOYEES_FOR_PROGRAM_FAILED',
};

export const GET_PAYMENTS_FOR_PROGRAM = {
  INITIATE: 'GET_PAYMENTS_FOR_PROGRAM_INITIATE',
  SUCCESS: 'GET_PAYMENTS_FOR_PROGRAM_SUCCESS',
  FAILED: 'GET_PAYMENTS_FOR_PROGRAM_FAILED',
};

export const GET_CREDIT_TRANSACTIONS_FOR_PROGRAM = {
  INITIATE: 'GET_CREDIT_TRANSACTIONS_FOR_PROGRAM_INITIATE',
  SUCCESS: 'GET_CREDIT_TRANSACTIONS_FOR_PROGRAM_SUCCESS',
  FAILED: 'GET_CREDIT_TRANSACTIONS_FOR_PROGRAM_FAILED',
};

export const UPDATE_PROGRAM_STATUS = {
  INITIATE: 'UPDATE_PROGRAM_STATUS_INITIATE',
  SUCCESS: 'UPDATE_PROGRAM_STATUS_SUCCESS',
  FAILED: 'UPDATE_PROGRAM_STATUS_FAILED',
};

export const getAllProgramsInitiate = payload => ({
  type: GET_PROGRAMS.INITIATE,
  payload,
});

export const getAllProgramsFailed = err => ({
  type: GET_PROGRAMS.FAILED,
  err,
});

export const getAllProgramsSuccess = programsData => ({
  type: GET_PROGRAMS.SUCCESS,
  programsData,
});

export const getTopProgramsInitiate = payload => ({
  type: GET_TOP_PROGRAMS.INITIATE,
  payload,
});

export const getTopProgramsFailed = err => ({
  type: GET_TOP_PROGRAMS.FAILED,
  err,
});

export const getTopProgramsSuccess = topPrograms => ({
  type: GET_TOP_PROGRAMS.SUCCESS,
  topPrograms,
});

export const reviewProgramInitiate = payload => ({
  type: REVIEW_PROGRAM.INITIATE,
  payload,
});

export const reviewProgramSuccess = reviewProgramDetails => ({
  type: REVIEW_PROGRAM.SUCCESS,
  reviewProgramDetails,
});

export const reviewProgramFailed = err => ({
  type: REVIEW_PROGRAM.FAILED,
  err,
});

export const createProgramInitiate = payload => ({
  type: CREATE_PROGRAM.INITIATE,
  payload,
});

export const createProgramFailed = err => ({
  type: CREATE_PROGRAM.FAILED,
  err,
});

export const createProgramSuccess = payload => ({
  type: CREATE_PROGRAM.SUCCESS,
  newProgram: payload,
});

export const getProgramInfoInitiate = payload => ({
  type: GET_PROGRAM_INFO.INITIATE,
  payload,
});

export const getProgramInfoFailed = err => ({
  type: GET_PROGRAM_INFO.FAILED,
  err,
});

export const getProgramInfoSuccess = programInfo => ({
  type: GET_PROGRAM_INFO.SUCCESS,
  programInfo,
});

export const getProgramDetailsInitiate = payload => ({
  type: GET_PROGRAM_DETAILS.INITIATE,
  payload,
});

export const getProgramDetailsFailed = err => ({
  type: GET_PROGRAM_DETAILS.FAILED,
  err,
});

export const getProgramDetailsSuccess = programData => ({
  type: GET_PROGRAM_DETAILS.SUCCESS,
  programData,
});

export const getProgramStatusInitiate = payload => ({
  type: GET_PROGRAM_STATUS.INITIATE,
  payload,
});

export const getProgramStatusFailed = err => ({
  type: GET_PROGRAM_STATUS.FAILED,
  err,
});

export const getProgramStatusSuccess = programStatus => ({
  type: GET_PROGRAM_STATUS.SUCCESS,
  programStatus,
});

export const reviewProgramToEmployeeMappingInitiate = payload => ({
  type: REVIEW_PROGRAM_TO_EMPLOYEE.INITIATE,
  payload,
});

export const reviewProgramToEmployeeMappingFailed = err => ({
  type: REVIEW_PROGRAM_TO_EMPLOYEE.FAILED,
  err,
});

export const reviewProgramToEmployeeMappingSuccess = reviewProgramMapping => ({
  type: REVIEW_PROGRAM_TO_EMPLOYEE.SUCCESS,
  reviewProgramMapping,
});

export const getEmployeesForProgramInitiate = payload => ({
  type: GET_EMPLOYEES_FOR_PROGRAM.INITIATE,
  payload,
});

export const getEmployeesForProgramSuccess = programEmployees => ({
  type: GET_EMPLOYEES_FOR_PROGRAM.SUCCESS,
  programEmployees,
});

export const getEmployeesForProgramFailed = err => ({
  type: GET_EMPLOYEES_FOR_PROGRAM.FAILED,
  err,
});

export const getPaymentsForProgramInitiate = payload => ({
  type: GET_PAYMENTS_FOR_PROGRAM.INITIATE,
  payload,
});

export const getPaymentsForProgramSuccess = programPayments => ({
  type: GET_PAYMENTS_FOR_PROGRAM.SUCCESS,
  programPayments,
});

export const getPaymentsForProgramFailed = err => ({
  type: GET_PAYMENTS_FOR_PROGRAM.FAILED,
  err,
});

export const getCreditTransactionForProgramInitiate = payload => ({
  type: GET_CREDIT_TRANSACTIONS_FOR_PROGRAM.INITIATE,
  payload,
});

export const getCreditTransactionForProgramSuccess = programCreditTransactions => ({
  type: GET_CREDIT_TRANSACTIONS_FOR_PROGRAM.SUCCESS,
  programCreditTransactions,
});

export const getCreditTransactionForProgramFailed = err => ({
  type: GET_CREDIT_TRANSACTIONS_FOR_PROGRAM.FAILED,
  err,
});

export const updateProgramStatusInitiate = payload => ({
  type: UPDATE_PROGRAM_STATUS.INITIATE,
  payload,
});

export const updateProgramStatusSuccess = response => ({
  type: UPDATE_PROGRAM_STATUS.SUCCESS,
  response,
});

export const updateProgramStatusFailed = err => ({
  type: UPDATE_PROGRAM_STATUS.FAILED,
  err,
});

export const ADD_OPTION = {
  INITIATE: 'ADD_OPTION_INITIATE',
  SUCCESS: 'ADD_OPTION_SUCCESS',
  FAILED: 'ADD_OPTION_FAILED',
};

export const UPDATE_OPTION = {
  INITIATE: 'UPDATE_OPTION_INITIATE',
  SUCCESS: 'UPDATE_OPTION_SUCCESS',
  FAILED: 'UPDATE_OPTION_FAILED',
};

export const UPDATE_OPTION_STATUS = {
  INITIATE: 'UPDATE_OPTION_STATUS_INITIATE',
  SUCCESS: 'UPDATE_OPTION_STATUS_SUCCESS',
  FAILED: 'UPDATE_OPTION_STATUS_FAILED',
};

export const CLEAR_PROGRAM_INFO = 'CLEAR_PROGRAM_INFO';

export const addOptionInitiate = payload => ({
  type: ADD_OPTION.INITIATE,
  payload,
});

export const addOptionSuccess = response => ({
  type: ADD_OPTION.SUCCESS,
  response,
});

export const addOptionFailed = err => ({
  type: ADD_OPTION.FAILED,
  err,
});

export const updateOptionInitiate = payload => ({
  type: UPDATE_OPTION.INITIATE,
  payload,
});

export const updateOptionSuccess = response => ({
  type: UPDATE_OPTION.SUCCESS,
  response,
});

export const updateOptionFailed = err => ({
  type: UPDATE_OPTION.FAILED,
  err,
});

export const updateOptionStatusInitiate = payload => ({
  type: UPDATE_OPTION_STATUS.INITIATE,
  payload,
});

export const updateOptionStatusSuccess = response => ({
  type: UPDATE_OPTION_STATUS.SUCCESS,
  response,
});

export const updateOptionStatusFailed = err => ({
  type: UPDATE_OPTION_STATUS.FAILED,
  err,
});

export const clearProgramInfo = () => ({
  type: CLEAR_PROGRAM_INFO,
});
